<template>
  <div>
    <el-form :model="form"  :rules="rules" ref="domain">
      <h3 class="login_title">{{ $t('msg.Change_personal_2_Password') }}</h3>
      <el-form-item :label="$t('msg.Old_personal2_password')" prop="old_password">
        <el-input type="password" v-model="form.old_password" :placeholder="$t('msg.Please_enter_your_old_password')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('msg.New_personal2_password')" prop="password">
        <el-input type="password" v-model="form.password" :placeholder="$t('msg.Please_enter_your_password')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('msg.Confirm_new_personal2_password')" prop="password2">
        <br>
        <el-input type="password" v-model="form.password2" :placeholder="$t('msg.Please_confirm_your_new_password')"></el-input>
      </el-form-item>
      <div style="text-align: center;">
        <el-button @click="updatePrivate" type="primary">{{ $t('msg.OK1') }}</el-button>
        <el-button @click="butCancel" type="primary">{{ $t('msg.Cancel') }}</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { UpdatePrivate } from "../api";
var LxStr = function(str){
  if(str){
    var arr = str.split('');
    var flag = true;
    for (var i = 1; i < arr.length-1; i++) {
      var firstIndex = arr[i-1].charCodeAt();
      var secondIndex = arr[i].charCodeAt();
      var thirdIndex = arr[i+1].charCodeAt();
      // thirdIndex - secondIndex == 1;
      // secondIndex - firstIndex==1;
      if((thirdIndex - secondIndex == 1)&&(secondIndex - firstIndex==1)){
        flag =  false;
      }
    }
    return flag;
  }
}
export default {
  name: "UpdatePrivateAside",
  data() {
    return {
      form: {
        old_password: '',
        password: '',
        password2: '',
      },
      rules: {
        old_password: [
          { required: true, message: this.$t('msg.Please_enter_your_password'), trigger: 'blur' },
          { min: 6, max: 6, message: this.$t('msg.Please_enter_a_numeric_value'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (isNaN(Number(value, 10))) {
                callback(new Error(this.$t('msg.Please_enter_a_numeric_value')));
              }else {
                callback();
              }
            },
            trigger: "blur"
          },
        ],
        password: [
          { required: true, message: this.$t('msg.Please_enter_your_password'), trigger: 'blur' },
          { min: 6, max: 6, message: this.$t('msg.Please_enter_a_numeric_value'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (isNaN(Number(value, 10))) {
                callback(new Error(this.$t('msg.Please_enter_a_numeric_value')));
              }else {
                callback();
              }
            },
            trigger: "blur"
          },
        ],
        password2: [
          { required: true, message: this.$t('msg.Please_enter_the_2nd_security_password'), trigger: 'blur' },
          { min: 6, max: 6, message: this.$t('msg.Please_enter_a_numeric_value'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (isNaN(Number(value, 10))) {
                callback(new Error(this.$t('msg.Please_enter_a_numeric_value')));
              }else {
                callback();
              }
            },
            trigger: "blur"
          },
        ],
      }
    }
  },
  methods: {
    butCancel() {
      this.form["old_password"] = ''
      this.form["password"] = ''
      this.form["password2"] = ''
    },
    updatePrivate() {

      var val = false
      var from = 'domain'
      this.$refs[from].validate(valid => {
        if (valid) {
          // 表单验证失败，显示错误消息...
          val = true
        }
      })
      if (!val){
        return;
      }
      if (this.form.password !== this.form.password2) {
        this.$alert(this.$t('msg.Password_mismatch_error'), '', {
          confirmButtonText: this.$t('msg.OK2'),
          center: true,
          customClass:'alert'//添加类名
        });
        return
      }
      if (this.form.password === this.form.old_password) {
        this.$alert(this.$t('msg.Password_used_before'), '', {
          confirmButtonText: this.$t('msg.OK2'),
          center: true,
          customClass:'alert'//添加类名
        });
        return
      }
      if (val) {
        UpdatePrivate(this.form).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            localStorage.removeItem('token')
            localStorage.removeItem('username')
            localStorage.removeItem('proxy_id')
            this.$alert(this.$t('msg.Change_success_relogin'), '', {
              confirmButtonText: this.$t('msg.OK2'),
              center: true,
              type: 'success',
              showClose: false,
              customClass:'alert'//添加类名
            }).then(() => {
              this.$router.push({ path: '/login' })
            });
          } else {
            var msg = this.$t('msg.Modification_failed')
            if (data.data.params.msg) {
              msg = data.data.params.msg
            }
            this.$alert(msg, '', {
              confirmButtonText: this.$t('msg.OK2'),
              center: true,
              customClass:'alert'//添加类名
            });
          }
        })
      }
    },
    label_width(){
      if(localStorage.getItem('lang')==='US'){
        return '350px'
      }
      return '180px'
    }
  }
}
</script>

<style lang="less">
.el-message-box {
  width: 500px;
  height: 150px;
}
/* 使用媒体查询来调整样式 */
@media screen and (max-width: 500px) {
  .alert{
    width: 240px;
  }
}
.el-form-item__label{
  white-space: nowrap;
}
</style>

<style lang="less" >
#selectForm .el-form-item__label {
  font-size: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/UpdatePrivateAside.vue